var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContractView',[_c('ProjectDetails',{attrs:{"isContractListView":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }